import React from 'react';
import PropTypes from 'prop-types';
import ContentCourseDetailScene from './ContentCourseDetailScene';
import ContentCourseDetailService from '../services/ContentCourseDetailService';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';

class ContentCourseDetailSceneContainer extends React.Component {
  static propTypes = {
    params: PropTypes.shape({
      courseId: PropTypes.string,
      moduleId: PropTypes.string,
      unitId: PropTypes.string,
    }).isRequired,
  };

  contentCourseDetailService = new ContentCourseDetailService();
  componentDidMount() {
    this.contentCourseDetailService.handleLoadCourse(this.props.params.courseId);

    if (this.props.params.moduleId) {
      this.contentCourseDetailService.handleLoadModule(this.props.params.moduleId);
    }

    if (this.props.params.moduleId && this.props.params.unitId) {
      this.contentCourseDetailService.handleLoadUnit(this.props.params.moduleId, this.props.params.unitId);
    }
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return JSON.stringify(nextProps.params) !== JSON.stringify(this.props.params);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.params.courseId !== this.props.params.courseId) {
      this.contentCourseDetailService.handleLoadCourse(this.props.params.courseId);
    }

    if (this.props.params.moduleId && this.props.params.moduleId !== prevProps.params.moduleId) {
      this.contentCourseDetailService.handleLoadModule(this.props.params.moduleId);
    }

    if (
      this.props.params.moduleId &&
      this.props.params.unitId &&
      this.props.params.unitId !== prevProps.params.unitId
    ) {
      this.contentCourseDetailService.handleLoadUnit(this.props.params.moduleId, this.props.params.unitId);
    }
  }

  render() {
    return (
      <ContentCourseDetailScene
        isLoading={
          this.contentCourseDetailService.fetchCourse.fetching ||
          this.contentCourseDetailService.fetchModule.fetching ||
          this.contentCourseDetailService.fetchUnit.fetching ||
          (this.props.params.courseId && !toJS(this.contentCourseDetailService.course)) ||
          (this.props.params.moduleId && !toJS(this.contentCourseDetailService.module)) ||
          (this.props.params.unitId && !toJS(this.contentCourseDetailService.unit))
        }
        course={this.props.params.courseId && toJS(this.contentCourseDetailService.course)}
        module={this.props.params.moduleId && toJS(this.contentCourseDetailService.module)}
        unit={this.props.params.unitId && toJS(this.contentCourseDetailService.unit)}
      />
    );
  }
}

export default observer(ContentCourseDetailSceneContainer);
